import { Calendar } from "@fullcalendar/core";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interaction from "@fullcalendar/interaction";
import ukLocale from "@fullcalendar/core/locales/uk";
import ruLocale from "@fullcalendar/core/locales/ru";

export const initSingleCalendar = (calendarEl) => {
  return new Calendar(calendarEl, {
    headerToolbar: {
      left: 'prev,next',
      center: 'title',
      right: 'today,timeGridDay,timeGridWeek,dayGridMonth',
    },
    eventColor: '#56c5a7',
    eventDisplay: 'block',
    displayEventTime: true,
    selectable: true,
    timeZone: calendarEl.dataset.timeZone,
    lazyFetching: false,
    scrollTime: '08:00:00',
    eventDidMount: function(info) {
      const desc = info.event?.extendedProps?.description

      if (!desc || is_touch_device) return;

      $(info.el).tooltip({
        title: desc,
        html: true,
        trigger: is_touch_device ? "focus" : "hover focus"
      })
    },
    events: function(
      { startStr, endStr },
      successCallback,
      failureCallback
    ) {
      const url =
        `/offices/${calendarEl.dataset.officeId}/appointments?q[day_gteq]=${startStr}&q[day_lteq]=${endStr}&display_coworkers=${calendarEl.dataset.displayCoworkers}`

      fetch(url, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        }
      })
        .then(res => res.json())
        .then(events => {
          successCallback(events)
        })
        .catch(err => failureCallback(err));
    },
    dateClick(info) {
      const url = `/offices/${calendarEl.dataset.officeId}/appointments/new`;
      openCalendarModal(url, info);
    },
    eventClick(info) {
      info.jsEvent.preventDefault();
      openCalendarModal(info.event.url, info);
    },
    plugins: [dayGridPlugin, timeGridPlugin, interaction],
    locales: [ukLocale, ruLocale],
    locale: calendarEl.dataset.locale
  });
}

const openCalendarModal = (url, info) => {
  $.ajax({
    url,
    dataType: 'script',
    data: {
      appointment: {
        day: info.dateStr
      }
    }
  })
}